export default __webpack_public_path__ + "static/hero-personal-loans-1-d9b4599ce7b9facfaa000326125409f4.webp";